export const breakpoints = {
  mobileSmall: 300,
  mobile: 360,
  mobilePortrait: 550,
  tabletPortrait: 768,
  tabletLandscape: 1024,
  desktop: 1366,
  desktopLarge: 1680
};

export const colors = {
  magenta: '#e20074',
  lowMagenta: '#f2dce7',
  white: '#ffffff',
  black: '#000000',
  darkGray: '#383838',
  gray: '#757575',
  mediumGray: '#8c8c8c',
  lightGray: '#c2c2c2',
  charcoalGray: '#262626',
  shadowGray: '#4b4b4b',
  ironGray: '#6c6c6c',
  stoneGray: '#7c7c7c',
  steelGray: '#a4a4a4',
  warmGray: '#d0d0d0',
  silverGray: '#e6e6e6',
  cloudGray: '#ededed',
  fogGray: '#f2f2f2',
  red: '#d90000',
  yellow: '#fecb00',
  green: '#6bb324',
  darkMagenta: '#c00063',
  lightMagenta: '#f3007d',
  coldGray: '#f6f6f6',
  lightishGray: '#e8e8e8',
  transparent: 'transparent',
  highLightGray: '#dddddd',
  semiLightGray: '#dddddd',
  orange: '#ff9a1e',
  lightOrange: '#fff4e9',
  darkOrange: '#d48936',
  ultraLightGray: '#dcdcdc',
  zBlack: '#323232',
  pictonBlue: '#53baf2',
  toryBlue: '#0F63AD',
  blumine: '#225482',
  extraDarkGray: '#d8d8d8',
  athensGray: '#f1f3f6',
  alabaster: '#f9f9f9',
  athensLightGray: '#fafbfc',
  galleryGray: '#eeeeee',
  successGreen: '#28a745',
  darkSuccessGreen: '#218838',
  dustyGray: '#949292',
  doveGray: '#676767',
  seaShellGray: '#f1f1f1',
  mauvelousPink: '#f18ec1',
  dullGray: '#f4f6f8',
  localGray: '#EAEDF0',
  lightBlack: '#181818',
  magentaHam: '#c2185b',
  darkPink: '#e20874',
  mediumPink: '#D3056C',
  darkGrey: '#0e0f11',

};

export const zindex = {
  header: 13,
  flowPanel: '100',
  informationTooltip: 1001,
  default: {
    mainHeader: 13
  },
  mobile: {
    mainHeader: 9999
  },
  desktop: {
    mainHeader: 101
  }
};

export const height = {
  default: {
    mainHeader: '3.75rem',
    maineHeaderTopStrip: '1.5rem',
    filterHeader: '2.75rem'
  }
};

// tslint:disable:eofline
export const boxShadow = `box-shadow: 0 6px 20px 0 rgba(0,0,0,0.1);`;
